import type { OverridableComponent } from '@material-ui/core/OverridableComponent'
import type { Theme } from '@material-ui/core/styles'
import { createStyles, withStyles } from '@material-ui/core/styles'
import type { TabsTypeMap } from '@material-ui/core/Tabs'
import MuiTabs from '@material-ui/core/Tabs'
import React from 'react'

const MUI_TABS_NULL_REF_PATTERN = /scrollTop|offsetHeight|offsetWidth/i

class TabsErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    if (MUI_TABS_NULL_REF_PATTERN.test(error.message)) {
      // Known MUI bug: Tabs/ScrollbarSize accessing DOM refs after unmount — suppress
      return
    }
    throw error
  }

  render() {
    if (this.state.hasError) {
      return null
    }
    return this.props.children
  }
}

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    indicator: {
      backgroundColor: theme.palette.primary.main
    },
    scrollButtons: {
      color: theme.palette.primary.main
    },
    flexContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      gap: theme.spacing(2.5)
    }
  })
}

const Tabs: OverridableComponent<TabsTypeMap> = (props: any) => (
  <TabsErrorBoundary>
    <MuiTabs {...props} />
  </TabsErrorBoundary>
)

export default withStyles(styles)(Tabs)
